import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WsSyncLogsRepository } from '../repositories/ws-sync-logs.repository';
import { WsSyncLog, WsSyncLogsQuery } from '../interfaces/ws-sync-log.types';

@Injectable({ providedIn: 'root' })
export class GetWsSyncLogsUseCase {
  private readonly repository = inject(WsSyncLogsRepository);

  execute(query: WsSyncLogsQuery): Observable<WsSyncLog[]> {
    return this.repository.getLogs(query);
  }
}
